import { GetInfos } from "../../../endpoints/information/GetInformationService";

export async function getInfos() {
  const infos = await GetInfos().then(
    (result) => result?.data?.[0]?.attributes ?? false
  );

  if (!infos) {
    throw new Error("infos_not_found");
  }
  if (!infos.integration_services_api_enabled) {
    throw new Error("disabled");
  }
  if (
    !infos.integration_services_api_url ||
    !infos.integration_services_api_token ||
    !infos.integration_services_api_key ||
    !infos.integration_services_api_lead_route
  ) {
    throw new Error("api_configuration_error");
  }
  return infos;
}
